import type { GetStaticPaths } from 'next';
import { getAllAltTagSlugs } from '@api';
export { default } from './page/[pageNo]';
export { getStaticProps } from './page/[pageNo]';

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: (await getAllAltTagSlugs()).map(
      (e) => `/knowledge/index/${e.slug || e.id}`
    ),
    fallback: 'blocking',
  };
};
